import type { NavChild } from "../nav-config";
import { type NavNode, hasActiveNode, matchesPath } from "./nav-tree";

/** Lug'at: `react-i18next` ning `t` iga bog'lanmaslik uchun oddiy imzo. */
type Translate = (key: string) => string;

/**
 * Menyu sozlamasidagi bandni chizuvchi komponentlarning modeliga o'giradi:
 * yorliq tarjima qilinadi, faollik joriy manzil bo'yicha hisoblanadi —
 * ichma-ich bandlarda ham.
 *
 * `end` — `NavLink end` bilan bir xil: band faqat aynan o'z manzilida faol
 * (`/dashboard` ning ichki sahifalari boshqaruv panelini belgilamaydi).
 * Bolali band o'z manzili bo'yicha emas, bolalari bo'yicha faol: uning `to`
 * si shunchaki birinchi bolaning manzili.
 */
export const toNavNode = (
  item: NavChild & { end?: boolean },
  pathname: string,
  t: Translate,
): NavNode => {
  const children = item.children?.length
    ? item.children.map(child => toNavNode(child, pathname, t))
    : undefined;

  const selfActive = item.end ? pathname === item.to : matchesPath(pathname, item.to);

  return {
    key: item.labelKey,
    href: item.to,
    label: t(item.labelKey),
    icon: item.icon,
    active: children ? hasActiveNode(children) : selfActive,
    children,
  };
};
